var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import LegalString from '@telus/uds-legals/LegalString';
import { Typography, Paragraph } from '@telus-uds/components-web';
import { getParagraphSize } from '../../helpers/richText';
import { RICH_TEXT_TYPES } from '../../types';
import { isUDSLegal } from '../Legal/utils';
var BLOCKS = RICH_TEXT_TYPES.BLOCKS;
export var buildParagraphFunction = function (_a) {
    var _b;
    var content = _a.content, listOptions = _a.listOptions, paragraphSize = _a.paragraphSize, alignText = _a.alignText, linesBetween = _a.linesBetween, EmbeddedInlineComponent = _a.EmbeddedInlineComponent, paragraph = _a.paragraph, embeddedInline = _a.embeddedInline, typographyBlock = _a.typographyBlock;
    return _b = {},
        _b[BLOCKS.PARAGRAPH] = function (node, children) {
            var resolvedParagraphSize = getParagraphSize(content, node, paragraphSize, listOptions);
            var paragraphColorVariant = paragraph === 'inverse' ? { inverse: true } : { colour: paragraph };
            // strips out any empty <p> tags
            var isEmptyChildren = (children === null || children === void 0 ? void 0 : children.toString().trim()) === '';
            if (isEmptyChildren)
                return null;
            var removePTag = node.content.find(function (item) { return item.nodeType === 'hyperlink' || item.nodeType === 'embedded-entry-inline'; });
            // removes the <p> tag and replaces it with a <div> around the component by default to avoid <div> within <p> nesting error
            if (removePTag)
                return (_jsx(Typography, { variant: __assign({}, (resolvedParagraphSize && { size: resolvedParagraphSize })), align: alignText, block: typographyBlock, children: children }));
            if (EmbeddedInlineComponent)
                return (_jsx(Typography, { variant: { colour: embeddedInline }, align: alignText, children: children }));
            var childrenAsString = React.Children.toArray(children).join('');
            var hasUDSLegal = isUDSLegal(childrenAsString);
            return (_jsx(Paragraph, { variant: __assign(__assign({}, paragraphColorVariant), (resolvedParagraphSize && { size: resolvedParagraphSize })), align: alignText, linesBetween: linesBetween, children: hasUDSLegal ? _jsx(LegalString, { children: childrenAsString }) : children }));
        },
        _b;
};
